// columns/ContextColumn.tsx
import React from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Tooltip, Typography } from "@mui/material";
import { Label } from "../../../model/Label";

const ContextCellRenderer = (params: GridRenderCellParams<Label>) => {
  const context = params.row.context || "No context";
  return (
    <Tooltip title={context} placement="top">
      <div className="px-2 py-1 bg-gray-50 rounded truncate max-w-[140px] text-sm border border-gray-100">
        {context}
      </div>
    </Tooltip>
  );
};

const ContextHeaderRenderer = () => (
  <Typography variant="subtitle2" fontWeight="medium">
    Context
  </Typography>
);

export const contextColumn: GridColDef = {
  field: "context",
  headerName: "Context",
  width: 150,
  headerClassName: "labels-table--header",
  renderHeader: ContextHeaderRenderer,
  renderCell: ContextCellRenderer,
};
